import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import EditCustomerSchool from './EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'

export default {
  props: {
    value: {
      default: undefined
    },
    getuseronly: {
      default: false
    },
    pageid: {
      default: undefined
    },
    loaduser: {
      default: true
    }
  },
  data: function() {
    return {
      loading: true,
      user: {},
      isEditTag: false,
      isEditSession: false,
      usertag: '',
      profile_pic: '',
      currentpageid: null,
      userSession: null
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    Tags
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      currentLang: 'currentLang'
    }),
    questionmessages() {
      if (this.value && this.$store.state.niveapage.includes(this.currentpageid)) {
        return this.value.questionmessages.split(';;')
      }
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.currentpageid)
    },
    filterIntent: function() {
      var vm = this
      return vm.user.intentlist.sort(function(a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function() {
      var vm = this
      return config.locale.find(function(locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    },
    shoplink() {
      var url = ''
      if (window.location.href.includes('cms.zwiz.app')) {
        url = 'https://shopv2.zwiz.app'
      } else if (window.location.href.includes('enterprise.zwiz.ai')) {
        url = 'https://shopcommu.zwiz.app'
      } else if (window.location.href.includes('localhost')) {
        url = 'https://shopv2.zwiz.app'
      } else {
        return false
      }

      var userid =
        this.$route.name == 'allinonechat'
          ? this.$store.state.livechat.pageid
          : this.selectedBot.pageid

      url =
        url +
        `/ecommerce/${userid}?userid=${this.user.id}&sessiontoken=${this.user.sessiontoken}&lang=${
          this.currentLang
        }&category=all&from=livechat`
      return url
    }
  },
  mounted: function() {
    if (this.pageid) {
      this.currentpageid = this.pageid
    } else {
      this.currentpageid = this.selectedBot.pageid
    }
    this.getuserDetail()
    // this.user = this.value
    // this.cached_tag = this.user.tags
  },
  methods: {
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    },
    getuserDetail() {
      let vm = this
      let data = { pageid: vm.currentpageid, userid: vm.value.id }
      if (!this.loaduser) {
        vm.loading = false
        vm.user = vm.value
        vm.setUserSession(vm.user.session)
      } else if (this.getuseronly) {
        api.getuserCustomerOnly(data, function(error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      } else {
        api.getuserCustomer(data, function(error, response) {
          if (error) console.error(error)
          vm.user = response.data[0]
          vm.setUserSession(vm.user.session)
          vm.loading = false
        })
      }
    },
    setUserSession(session) {
      if (session) {
        try {
          this.userSession = JSON.parse(session)
        } catch (e) {
          this.userSession = session
        }
      }
    },
    editSession() {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        params: {
          pageid: vm.currentpageid
        },
        body: {
          usersid: this.user.id,
          session: this.userSession || ''
        }
      }
      api.saveusersession(data, (error, response) => {
        if (response.responsecode == 200) {
          vm.$store.dispatch('loading')
          this.isEditSession = false
        }
        if (error) {
          vm.$store.dispatch('loading')
          vm.$swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'กรุณาลองใหม่อีกครั้ง',
            type: 'error',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        }
      })
    },
    deleteSession(key) {
      delete this.userSession[key]
      this.isEditSession = false
      this.isEditSession = true
    },
    cancleEditSession() {
      this.setUserSession(this.user.session)
      this.isEditSession = false
    },
    onEditAddress(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        address: payload.customer_value || ''
      }
      api.saveUserAddress(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value || ''
      }
      api.saveUserContext(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    saveEditTag: function() {
      var vm = this
      var data = {
        pageid: vm.currentpageid,
        usersid: vm.user.id,
        tags: vm.user.tags || ''
      }
      api.saveUserTags(data, function(error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function() {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function() {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value || ''
      }
      api.saveUserStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditLineId: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value || ''
      }
      api.saveUserLineId(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value || ''
      }
      api.saveUserSchool(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value || ''
      }
      api.saveUserProvince(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/dashboard/CustomerDetail.js